import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Nav, NavItem, NavLink } from "reactstrap"
import SimpleBar from "simplebar-react"
import { useSelector, useDispatch } from "react-redux"
import { getUsers as onGetUsers } from "store/user/actions"
import { getGuests as onGetGuests } from "store/guest/actions"
import { statusTypes, guestAccessType } from "../../constants/common"
import { getSeasonPasses as onGetSeasonPasses } from "store/season-pass/actions"
import BootstrapTable from "react-bootstrap-table-next"
import PropTypes from "prop-types"
import { convertUtcToLocal } from "../../helpers/util"
import { isEmpty, map } from "lodash"

const ApprovalRequest = () => {
  const dispatch = useDispatch()

  const [activeTab, setActiveTab] = useState("user")

  const { users, guests, seasonPassData } = useSelector(state => ({
    users: state.users.userList,
    guests: state.guests.guestList,
    seasonPassData: state.seasonPass.seasonPassList,
  }))

  useEffect(() => {
    if (isEmpty(seasonPassData)) {
      dispatch(onGetSeasonPasses())
    }
  }, [])

  useEffect(() => {
    if (activeTab == "guest") {
      dispatch(onGetGuests({ status: [statusTypes.Approved, statusTypes.Available], accessStatus: statusTypes.Pending }))
    } else if (activeTab == "user") {
      dispatch(onGetUsers({ status: [statusTypes.Pending] }))
    } else if (activeTab == "season") {
      dispatch(onGetUsers({ seasonChangeStatus: guestAccessType.Pending }))
    }
  }, [activeTab])

  return (
    <React.Fragment>
      <Col xl={12}>
        <Card className="card-h-100">
          <div className="bg-transparent border-bottom card-header">
            <div className="d-flex flex-wrap">
              <div className="me-2">
                <h5 className="card-title mt-1 mb-4">Approval Request</h5>
              </div>
              <Nav
                className="nav-tabs nav-tabs-custom card-header-tabs ms-auto gap-1"
                role="tablist"
              >
                <NavItem className="ms-1" onClick={() => setActiveTab("user")}>
                  <NavLink
                    href="#"
                    className={activeTab == "user" ? "active" : ""}
                  >
                    User
                  </NavLink>
                </NavItem>
                <NavItem className="ms-1" onClick={() => setActiveTab("guest")}>
                  <NavLink
                    href="#"
                    className={activeTab == "guest" ? "active" : ""}
                  >
                    Guest
                  </NavLink>
                </NavItem>
                <NavItem
                  className="ms-1"
                  onClick={() => setActiveTab("season")}
                >
                  <NavLink
                    href="#"
                    className={activeTab == "season" ? "active" : ""}
                  >
                    Season Change
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </div>
          <CardBody>
            <SimpleBar style={{ maxHeight: "500px" }}>
              <div>
                <div className="tab-content">
                  <div className="tab-pane show active">
                    {activeTab == "user" ? (
                      <UserTableView data={users} />
                    ) : activeTab == "guest" ? (
                      <GuestTableView data={guests} />
                    ) : (
                      <UserSeasonChangeTableView
                        data={users}
                        seasonPassData={seasonPassData}
                      />
                    )}
                  </div>
                </div>
              </div>
            </SimpleBar>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  )
}

const UserTableView = ({ data }) => {
  const userListColumns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
      formatter: record => <>{record._id}</>,
    },
    {
      text: "User Name",
      dataField: "name",
      sort: true,
    },
    {
      text: "Role",
      dataField: "roleId",
      sort: true,
      formatter: (cellContent, user) => (
        <p className="text-muted mb-0">{user?.role?.roleTitle || ""}</p>
      ),
    },
    {
      text: "Season Title",
      dataField: "season",
      sort: true,
      formatter: (cellContent, user) => {
        return (
          <>
            <h5 className="font-size-14 mb-1">
              <Link to="#" className="text-dark">
                {user?.season?.seasonTitle || ""}
              </Link>
            </h5>
          </>
        )
      },
    },
    {
      text: "Primary Location",
      dataField: "primaryStation",
      sort: true,
    },
  ]
  return (data || []).length > 0 ? (
    <BootstrapTable
      data={data || []}
      columns={userListColumns}
      keyField={"_id"}
      //defaultSorted={defaultSorted}
      classes={"table align-middle table-nowrap table-hover"}
      bordered={false}
      striped={false}
      responsive
      //ref={node}
    />
  ) : (
    <div className="text-center">
      <h4 className="mb-0 font-size-14">No pending approval request </h4>
    </div>
  )
}

UserTableView.propTypes = {
  data: PropTypes.array,
}

const GuestTableView = ({ data }) => {
  const columns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
      formatter: record => <>{record._id}</>,
    },
    {
      text: "Guest Name",
      dataField: "guestName",
      sort: true,
    },
    {
      dataField: "sponsor.name",
      text: "sponsor",
      sort: true,
      formatter: (cellContent, record) => {
        return <p>{record?.sponsor?.name || ""}</p>
      },
    },
    {
      text: "Access Date",
      dataField: "accessDate",
      sort: true,
      formatter: (cellContent, record) => {
        return (
          <div style={{ whiteSpace: "normal" }}>
            {convertUtcToLocal(record?.visitDate)}
          </div>
        )
      },
    },
    {
      text: "Access Location",
      dataField: "accessLocation",
      sort: true,
      formatter: (cellContent, record) => {
        return (
          <div style={{ whiteSpace: "normal" }}>
            {record?.carPark?.carParkTitle}
          </div>
        )
      },
    },
  ]
  return (data || []).length > 0 ? (
    <BootstrapTable
      data={data || []}
      columns={columns}
      keyField={"_id"}
      //defaultSorted={defaultSorted}
      classes={"table align-middle table-nowrap table-hover"}
      bordered={false}
      striped={false}
      responsive
      //ref={node}
    />
  ) : (
    <div className="text-center">
      <h4 className="mb-0 font-size-14">No pending approval request </h4>
    </div>
  )
}

GuestTableView.propTypes = {
  data: PropTypes.array,
}

const UserSeasonChangeTableView = ({ data, seasonPassData }) => {
  const getSeason = id => {
    if (seasonPassData) {
      const season = seasonPassData.find(el => el._id == id)
      if (season) {
        return season
      }
    }
    return null
  }
  const columns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
      formatter: record => <>{record._id}</>,
    },
    {
      text: "User Name",
      dataField: "name",
      sort: true,
    },
    {
      text: "Role",
      dataField: "roleId",
      sort: true,
      formatter: (cellContent, user) => (
        <p className="text-muted mb-0">{user?.role?.roleTitle || ""}</p>
      ),
    },
    {
      text: "Current Season",
      dataField: "season",
      sort: true,
      formatter: (cellContent, user) => {
        return (
          <>
            <h5 className="font-size-14 mb-1">
              <Link to="#" className="text-dark">
                {user?.season?.seasonTitle || ""}
              </Link>
            </h5>
          </>
        )
      },
    },
    {
      dataField: "newSeason",
      text: "New Season",
      sort: true,
      formatter: (cellContent, record) => {
        const changeSeason = (record?.changeSeason || []).find(
          el => el.status == guestAccessType.Pending
        )
        const season = getSeason(changeSeason?.newSeason || "")
        return (
          <>
            <p className="text-muted mb-0">{season?.seasonTitle || ""}</p>
          </>
        )
      },
    },
  ]
  return (data || []).length > 0 ? (
    <BootstrapTable
      data={data || []}
      columns={columns}
      keyField={"_id"}
      //defaultSorted={defaultSorted}
      classes={"table align-middle table-nowrap table-hover"}
      bordered={false}
      striped={false}
      responsive
      //ref={node}
    />
  ) : (
    <div className="text-center">
      <h4 className="mb-0 font-size-14">No pending approval request </h4>
    </div>
  )
}

UserSeasonChangeTableView.propTypes = {
  data: PropTypes.array,
  seasonPassData: PropTypes.array,
}

export default ApprovalRequest
